import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import '@/assets/styles/main.scss';
import '@/assets/styles/reset.scss';
import { Drawer } from '@/components/Drawer';
import { DrawerProvider } from '@/contexts/drawerContext';
import { AppRoutes } from '@/routes';
import { store } from '@/store';

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <DrawerProvider>
        <Provider store={store}>
          <AppRoutes />
          <Drawer />
        </Provider>
      </DrawerProvider>
    </BrowserRouter>
  </StrictMode>
);
